import { render, staticRenderFns } from "./ModalImportKeyword.vue?vue&type=template&id=588f5944&scoped=true&"
import script from "./ModalImportKeyword.vue?vue&type=script&lang=js&"
export * from "./ModalImportKeyword.vue?vue&type=script&lang=js&"
import style0 from "./ModalImportKeyword.vue?vue&type=style&index=0&id=588f5944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f5944",
  null
  
)

export default component.exports